import { getProviderLicensesStatus, isApiError, postProviderStatesSelection } from '@uplift/api';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { providerQueryKeys } from './providerQueryKeys';

export const useProviderLicensesStatusQuery = (providerId: string) => {
  return useQuery({
    queryKey: providerQueryKeys.statesSelection(providerId),
    queryFn: async() => {
      const response = await getProviderLicensesStatus(providerId);

      return response.data;
    },
  });
};

export const useProviderStatesSelectionMutation = (providerId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: providerQueryKeys.statesSelection(providerId),
    mutationFn: async(args: { stateIds: string[]; setLive: boolean }) => {
      const response = await postProviderStatesSelection(providerId, args.stateIds, args.setLive);

      return response.data;
    },
    async onError(e) {
      if (isApiError(e)) {
        throw new Error(e.response?.data.error);
      } else if (e instanceof Error) {
        throw new Error(e.message);
      } else {
        console.error('An unknown error occurred:', e);
      }
    },
    async onSuccess() {
      await Promise.all([
        queryClient.invalidateQueries(providerQueryKeys.statesSelection(providerId)),
        queryClient.invalidateQueries(providerQueryKeys.licenses(providerId)),
        queryClient.invalidateQueries(providerQueryKeys.activationEvents(providerId)),
      ]);
    },
  });
};
